import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Badge, Button, InputGroup, Form, Spinner, Container } from 'react-bootstrap';
import { DataManager } from '../../core/data-manager';
import { ApiManager } from '../../core/api-manager';
import { LanguageProvider } from '../../core/language-provider';
import moment from 'moment';
import { Utils } from '../../core/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';



export default function DataGridTopHook({ entity, data, setData, searchObj, setSearchObj }) {

    const [errors, setErrors] = useState('');
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    const [dateFrom, setDateFrom] = useState(
        searchObj?.constraints?.find(f=> f.type === "greater") ? moment(searchObj?.constraints?.find(f=> f.type === "greater").value).format('YYYY-MM-DD') : null
    );
    const [dateTo, setDateTo] = useState(
        searchObj?.constraints?.find(f=> f.type === "minor") ? moment(searchObj?.constraints?.find(f=> f.type === "minor").value).subtract(1, 'days').format('YYYY-MM-DD') : null
    );

    useEffect(() => {
        console.log(searchObj, dateTo, dateFrom)
    }, []);

    function filterByDate() {
        if (dateFrom && dateTo) {
            var s = Utils.cloneObject(searchObj)
            var c = s.constraints
            var ct = []

            for (var i = 0; i < c.lenght; i++) {
                if (c[i].fieldName !== 'date') {
                    ct.push(c[i])
                }
            }
            ct.push({
                fieldName: 'date',
                type: 'greater',
                value: moment(dateFrom, 'YYYY-MM-DD').format('YYYY-MM-DDT00:00')
            })
            ct.push({
                fieldName: 'date',
                type: 'minor',
                value: (moment(dateTo, 'YYYY-MM-DD').add(1, 'days')).format('YYYY-MM-DDT00:00')
            })

            s.constraints = ct
            setSearchObj(s)
        }
        else {
            setErrors('Seleziona le date per procedere.')
            setTimeout(() => {
                setErrors('')
            }, "3000")
        }
    }


    function filterReset() {
        setDateFrom("")
        setDateTo("")
        var s = Utils.cloneObject(searchObj)
        s.constraints = []
        console.warn(s)
        setSearchObj(s)
    }





    if (entity !== null) {
        return (
            <>
                {(() => {
                    switch (entity) {
                        case 'sample': return (
                            <span>Test</span>
                        );
                        case 'gyv_episode_user': return (
                            <>
                                <Container fluid>
                                    <div className='d-flex flex-row'>
                                        <InputGroup className="mt-2 mb-3" style={{ maxWidth: 700 }}>
                                            <Form.Control value={dateFrom} type="date" onChange={(event) => setDateFrom(event.target.value)} />
                                            <Form.Control value={dateTo} type="date" onChange={(event) => setDateTo(event.target.value)} />
                                            {loading ? (
                                                <Button size='md' variant='primary' disabled><Spinner /></Button>
                                            ) : (
                                                <Button size='md' variant='primary' onClick={() => filterByDate()}>Filtra per data</Button>
                                            )}
                                            {searchObj && searchObj.constraints.length !== 0 ? <>
                                                <Button onClick={() => filterReset()} size='md' variant='danger' className='me-2'>Resetta filtri</Button>
                                            </> : null}
                                        </InputGroup>
                                        <Button className="mt-2 mb-3 ms-2" variant='success' onClick={() => navigate('/page/CreateUserEpisode')}><FontAwesomeIcon icon="plus" /> Crea record</Button>
                                    </div>

                                </Container>
                            </>
                        );
                        default: return (
                            <></>
                        );
                    }
                })()}
            </>
        )
    }
    else {
        return (
            <></>
        )
    }
};